import React from "react";
import { CircleCheck } from "lucide-react";
import { BEFORE_AFTER } from "@/constants/brand";

export default function ResultsSection() {
    return (
        <section
            data-testid="results-section"
            id="results"
            className="py-16 sm:py-20 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-12">
                    <span className="text-gold-600 font-bold text-xs uppercase tracking-[0.25em] block mb-3">
                        Asli Nataij
                    </span>
                    <h2 className="font-serif text-4xl sm:text-5xl font-bold text-forest-800 leading-tight">
                        Asli results. Asli{" "}
                        <span className="italic">Pakistani</span> customers.
                    </h2>
                    <p className="text-forest-900/70 mt-4 text-base sm:text-lg">
                        Dermalist Rosemary Serum roz lagane se pehle aur baad ka
                        farq — khud dekh lein.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
                    {BEFORE_AFTER.map((r, idx) => (
                        <div
                            key={idx}
                            data-testid={`result-card-${idx}`}
                            className="bg-white rounded-3xl p-5 border border-forest-100 shadow-sm hover:shadow-xl transition-all flex flex-col"
                        >
                            <div className="grid grid-cols-2 gap-2 mb-4">
                                <div className="relative rounded-2xl overflow-hidden bg-forest-50 aspect-square">
                                    <span className="absolute top-2 left-2 bg-forest-900/80 text-white text-[10px] font-bold px-2 py-0.5 rounded">
                                        PEHLE
                                    </span>
                                    <img
                                        src={r.before}
                                        onError={(e) => {
                                            e.currentTarget.src = `https://placehold.co/400x400/e5dec9/8f6b22?text=Before`;
                                        }}
                                        alt={`Before - ${r.title}`}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="relative rounded-2xl overflow-hidden bg-forest-100 aspect-square">
                                    <span className="absolute top-2 right-2 bg-forest-800 text-gold-400 text-[10px] font-bold px-2 py-0.5 rounded">
                                        {r.afterLabel}
                                    </span>
                                    <img
                                        src={r.after}
                                        onError={(e) => {
                                            e.currentTarget.src = `https://placehold.co/400x400/163721/e4c267?text=After`;
                                        }}
                                        alt={`After - ${r.title}`}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                            <h3 className="font-serif font-bold text-forest-800 text-lg mb-2">
                                {r.title}
                            </h3>
                            <p className="text-sm text-forest-900/70 leading-relaxed mb-4 flex-1">
                                "{r.quote}"
                            </p>
                            <div className="pt-3 border-t border-forest-100 flex items-center justify-between text-xs">
                                <span className="font-semibold text-forest-800 flex items-center gap-1.5">
                                    <CircleCheck className="w-4 h-4 text-forest-600" />
                                    {r.name}
                                </span>
                                <span className="text-forest-700/60">
                                    Tasdeeq Shuda Khareedar
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
